import React from 'react';

import { EmailCtaRedirect } from './EmailCtaRedirect';

/**
 * Preserves the query string (UTMs, etc.) while replacing the path with `/chat`.
 * Used only from email/onboarding CTA routes — see `routes-with-error-boundaries.tsx`
 * (`/email/...` preferred for new links; `/upload` and siblings are legacy short URLs).
 */
export function EmailCtaRedirectToChat(): React.ReactElement {
  return <EmailCtaRedirect to='/chat' />;
}
